import React, { useEffect, useState } from 'react'
import { HiOutlineSparkles } from "react-icons/hi2";
import listingDefaulImage from "../assets/listing-default.jpg";
import { isImageURL } from "../utils/helpers";
import { FiArrowUpRight } from "react-icons/fi";
import { FaStar } from 'react-icons/fa';
import { FiStar } from "react-icons/fi";
import { IoEyeOutline } from "react-icons/io5";
import { CgNotes } from "react-icons/cg";
import { PiHouseSimpleBold } from "react-icons/pi";


const ListingCard = ({ listing, setNotesPopup, clientId, saveUnsaveListing, savedListingView}) => {
const [isFavorite, setIsFavorite] = useState(false);
const [hasNotes, setHasNotes] = useState(false);

useEffect(() => {
    setIsFavorite(savedListingView || listing.is_saved ? true : false);
    setHasNotes(listing.notes && listing.notes.length > 0 ? true : false);
  },[]);

  const handleFavoriteClick = () => {
    setIsFavorite(!isFavorite);
    saveUnsaveListing(!isFavorite,listing.answer_hash)
}

const handleNotesClick = () => {
    if(!listing.notes){
        listing.notes =[]
    }
    setNotesPopup(listing.notes, listing.answer_hash);
}

    return (
        <div id="listingCard" className="card p-3 bg-white shadow-sm grid lg:grid-flow-col gap-x-3 gap-y-4 ms-1 me-1 transition-transform duration-300 hover:scale-[1.01]">
            <div className="img relative md:w-60">
                <img src={
                    listing.media?.length > 0 ? listing.media?.filter(obj => isImageURL(obj.url))[0].url : listingDefaulImage
                } alt="" className="listing-image" />
                <div className="absolute bottom-0 right-0 w-full bg-gradient-to-b from-transparent to-black bg-opacity-40">
                    <div className="bg-white bg-opacity-30 grid grid-cols-3 gap-3 px-3 py-2 border-t border-[#FFFFFF80] border-solid ">
                        <h6 className="text-white flex flex-col">
                            <span>{listing.bedrooms}</span>
                            <span>beds</span>
                        </h6>
                        <h6 className="text-white flex flex-col">
                            <span>{listing.bathrooms_total}</span>
                            <span>baths</span>
                        </h6>
                        <h6 className="text-white flex flex-col">
                            <span>{listing.living_area}</span>
                            <span>sqft</span>
                        </h6>
                    </div>
                </div>
            </div>
            <div className="content flex flex-col">
                <div className="grid md:grid-cols-[2fr,auto,auto] basis-1/5">
                    <h4 className="text-[#101828] capitalize font-bold text-lg line-clamp-2">{listing.address}</h4>
                    { clientId && (
                    <div className='flex items-center justify-end space-x-2'>
                        <div className={`${isFavorite ? 'bg-[#F6F8FC]' : ''} cursor-pointer rounded-full p-2.5 hover:bg-[#F6F8FC]`} onClick={handleFavoriteClick}>
                            { isFavorite ? (
                                <FaStar 
                                    size={20}
                                    className="text-[#F6B554] hover:text-[#98A2B3] hover:scale-105"
                                />
                                ):(
                                <FiStar 
                                    size={20}
                                    className="text-[#98A2B3] hover:text-[#F6B554] hover:scale-105"
                                />  
                            )}
                        </div>
                            { isFavorite && (
                                <div className='bg-[#F6F8FC] rounded-xl p-1.5 cursor-pointer' onClick={handleNotesClick}>
                                    { hasNotes ? (
                                        <div className="text-[#98A2B3] p-1 flex items-center hover:text-[#0062FF] hover:scale-105">
                                            <IoEyeOutline 
                                                    size={20}
                                                    className="mr-1"
                                            />
                                        </div>
                                        ):(
                                        <div className="text-[#0062FF] p-1 flex items-center hover:text-[#0062FF] hover:scale-105">    
                                            <CgNotes 
                                                size={20}
                                            />
                                        </div>  
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className="flex flex-col justify-between basis-4/5">
                    <div className="grid grid-flow-col lg:gap-2 mt-2 mb-2">
                        <HiOutlineSparkles size={18} className="hidden lg:flex text-[#626D7D]" />
                        <p className="text-[#475467] line-clamp-4 text-sm">{listing.synopsis}</p>
                    </div>
                    <div className="flex justify-between item-center">
                        <div className="flex items-center">
                            <h4 className="text-[#101828] capitalize font-bold mr-4">{listing.list_price}</h4>
                            {listing.fsbo && 
                                (<p className="flex items-center bg-[#FF8126] text-white pr-3 pl-3 rounded-md">
                                    <PiHouseSimpleBold className="mr-2" /> FSBO Property
                                </p>)
                            }
                            
                        </div>
                        <a href={`${window.location.origin}/n/${listing.answer_hash}`} target="_blank" className="flex gap-1">
                            <span className="text-base text-[#0062FF] font-bold hover:underline">View listing</span>
                            <FiArrowUpRight size={22} className="text-sm text-[#0062FF]" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ListingCard;